export const isToday = (iso) => {
  if (!iso) return false;
  const d = new Date(iso);
  const now = new Date();

  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
};

export const formatAuditTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const extractTargetFromDescription = (desc) => {
  if (!desc) return "";

  let match = desc.match(/visor\s+'([^']+)'/i);
  if (match) return match[1];

  match = desc.match(/user\s+'([^']+)'/i);
  if (match) return match[1];

  return desc;
};

export const extractRequesterFromDescription = (desc) => {
  if (!desc) return "Support";
  const match = desc.match(/by\s+'([^']+)'/i);
  return match?.[1] || "Support";
};
